import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CreNgConfig } from 'cre-ng';

import { WindowService } from '@app/core/window.service';
import { TableColumn } from '@app/shared';
import { AuthService } from '@app/core/auth.service';
import { DriverSearch, DriverSearchParams } from './search.models';
import { SearchService } from './search.service';

@Component({
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css'],
})
export class SearchComponent implements OnInit {
  areDriverSearchResultsVisible: boolean;
  driverCodeFormControl: FormControl;
  driverSearchColumns: TableColumn[];
  driverSearchForm: FormGroup;
  driverSearchResults: DriverSearch[] = [];
  isDriverSearchLoading: boolean;
  isLoading: boolean;

  private fleets: string[] = [];

  constructor(
    private authService: AuthService,
    private creNgConfig: CreNgConfig,
    private searchService: SearchService,
    private router: Router,
    @Inject(WindowService) private windowService: Window
  ) {}

  clearForm() {
    this.driverSearchForm.reset({
      driverCode: null,
    });

    this.driverSearchForm.markAsPristine();

    this.areDriverSearchResultsVisible = false;
  }

  ngOnInit() {
    this.isLoading = true;
    this.driverCodeFormControl = new FormControl(null);

    this.driverSearchForm = new FormGroup({
      driverCode: this.driverCodeFormControl,
    });

    this.driverSearchColumns = [
      { field: 'driverCode', header: 'Driver Code' },
      { field: 'firstName', header: 'First Name' },
      { field: 'lastName', header: 'Last Name' },
      { field: 'phoneNumber', header: 'Phone' },
      { field: 'fleet', header: 'Fleet' },
    ];

    this.searchService
      .getFleets(this.authService.getCurrentUser().username)
      .then((data) => {
        this.fleets = data;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  onRowDblClick(_event: any, data: DriverSearch) {
    const url = new URL(this.windowService.location.href);
    void this.router.navigateByUrl(`${data.driverCode}` + url.search).then(() => {
      this.windowService.location.reload();
    });
  }

  searchDrivers() {
    this.isDriverSearchLoading = true;
    this.areDriverSearchResultsVisible = false;
    this.driverSearchResults = [];

    const params = <DriverSearchParams>{
      fleets: this.fleets,
      driverCode: this.driverCodeFormControl.value,
    };
    this.searchService
      .driverSearch(params)
      .then((data) => {
        this.driverSearchResults = data;
      })
      .catch((error) => {
        this.driverSearchResults = [];
      })
      .finally(() => {
        this.isDriverSearchLoading = false;
        this.areDriverSearchResultsVisible = true;
      });
  }
}
